export function useReviewRating() {
    /**
     * How many stars a rating fills. Only a whole number from 1 to 5 is a rating: a redisplayed
     * "4.5", "0" or "" is what the server just rejected, and none of them fills a star.
     */
    function filledStars(rating: unknown): number {
        return /^[1-5]$/.test(String(rating)) ? Number(rating) : 0;
    }

    return {
        filledStars,
    };
}
